"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _ModalRoutingContext = _interopRequireDefault(require("./ModalRoutingContext"));

var ReplaceComponentRenderer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ReplaceComponentRenderer, _React$Component);

  function ReplaceComponentRenderer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      prevProps: null,
      props: null,
      pathname: null
    });
    return _this;
  }

  ReplaceComponentRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // TODO: handle history changes
    if (props.location.pathname !== state.pathname) {
      return (0, _extends2.default)({
        pathname: props.location.pathname,
        props: props
      }, !_lodash.default.get(state, 'props.location.state.modal') && {
        prevProps: state.props
      });
    }
  };

  var _proto = ReplaceComponentRenderer.prototype;

  _proto.render = function render() {
    // render modal if props location has modal
    var _this$props = this.props,
        pageResources = _this$props.pageResources,
        location = _this$props.location,
        modalProps = _this$props.modalProps;
    var prevProps = this.state.prevProps;

    var isModal = prevProps && _lodash.default.get(location, 'state.modal');

    var resources = isModal ? prevProps.pageResources : pageResources;
    var pageElement = isModal ? _react.default.createElement(prevProps.pageResources.component, (0, _extends2.default)({}, prevProps, {
      key: prevProps.pageResources.page.path
    })) : _react.default.createElement(pageResources.component, (0, _extends2.default)({}, this.props, {
      key: pageResources.page.path
    }));
    var modalElement = isModal ? _react.default.createElement(pageResources.component, (0, _extends2.default)({}, this.props, {
      key: pageResources.page.path
    })) : null;
    return _react.default.createElement(_react.default.Fragment, null, pageElement, _react.default.createElement(_reactModal.default, (0, _extends2.default)({}, modalProps, {
      isOpen: !!modalElement
    }), modalElement ? _react.default.createElement(_react.default.Fragment, {
      key: this.props.location.key
    }, _react.default.createElement(_ModalRoutingContext.default.Provider, {
      value: {
        modal: isModal,
        closeTo: prevProps.location.pathname
      }
    }, modalElement)) : null));
  };

  return ReplaceComponentRenderer;
}(_react.default.Component);

var replaceComponentRenderer = function replaceComponentRenderer(_ref, opts) {
  var props = _ref.props;
  var modalProps = opts.modalProps;
  return _react.default.createElement(ReplaceComponentRenderer, (0, _extends2.default)({}, props, {
    modalProps: modalProps
  }));
};

var _default = replaceComponentRenderer;
exports.default = _default;